var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.41 14.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #999;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.01,1.25c-.08-.43.2-.46.44-.51s.47-.08.71-.12c.37-.07.53.04.59.42.1.56.2,1.12.3,1.67,0,.02,0,.04.02.08.06-.07.1-.12.15-.17C3.23,1.47,4.46.66,5.93.28,8.09-.29,10.14,0,12.01,1.22c1.71,1.11,2.83,2.68,3.22,4.69.58,2.94-.29,5.43-2.58,7.38-1.01.87-2.2,1.41-3.52,1.6-2.66.38-4.94-.39-6.78-2.38-.97-1.05-1.56-2.3-1.82-3.71-.05-.26.08-.45.33-.49.29-.05.58-.1.88-.15.34-.05.49.05.55.39.1.52.26,1.01.49,1.48.65,1.27,1.61,2.21,2.94,2.74,1.63.66,3.25.6,4.82-.2,1.23-.63,2.11-1.6,2.65-2.87.34-.81.49-1.66.43-2.53-.1-1.56-.73-2.89-1.9-3.94-1.23-1.1-2.69-1.57-4.33-1.43-1.5.13-2.74.78-3.75,1.89-.02.02-.04.05-.09.11.31-.05.58-.1.84-.15.31-.05.61-.11.92-.16.34-.06.5.05.56.39.05.29.1.57.15.86.04.25-.09.44-.33.48-1.48.26-2.95.52-4.43.78-.27.05-.44-.08-.49-.36-.12-.64-.23-1.28-.34-1.93C.29,2.92.03,1.38.01,1.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskReset);
export default __webpack_public_path__ + "static/media/TaskReset.59f9ccb7b88e696789aa125366704e31.svg";
export { ForwardRef as ReactComponent };